import { getAppUrl } from '@bugseq-site/shared/src/env'

export function redirectToSignUp (): void {
  window.location.replace(`${getAppUrl()}/register`)
}
